module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_01-3cbef08d9d71222622b0b8460b8b4d86.webp";